import React from "react";

import Head_logo from "../../data/img/head_log.png"

const Logo = (props) => {
    //console.log(props.y);
    return(
        <a href="/">
            <div className={props.y<100?"logo_ori":"logo_cha"}>
                <img src={Head_logo}></img>
            </div>
        </a>
    )
}

export default Logo;